import { createStore } from "vuex" 
import VuexReset from '@ianwalter/vuex-reset'
//import axios from 'axios'

const store = createStore({
   plugins: [VuexReset()],
   state:{
      host:import.meta.env.VITE_APP_HOST,
      port:import.meta.env.VITE_APP_PORT_WEBSOCKET,
      api:import.meta.env.VITE_APP_API_URL,
      apifile:import.meta.env.VITE_APP_API_FILE,
      linkMail:import.meta.env.VITE_APP_LINK_MAIL,

      elementSearch:{},
      dataAccueil:'',
      routerLastPosition:{},
      notifications:[],
      coupons:[],
      mesAbonnees:[],
      servicesClient:[{
            numero:93513618,
         },
         {
            numero:690897983,
         }
      ],
      heure:'',
      realTime:'00:00:00',
      scrollFilterAccueil:0,
      dataArticles:[],
      listCategorieSelect:[],
      boutiques:[],
      rangeSelect:[1,9999999999999],
      toutMesArticles:[],
      mesArticlesEnVentes:[],
      mesArticlesNonVendus:[],
      mesArticlesVendus:[],
      mesArticlesEnCourDeVente:[],
      nbrVendu:0,
      nbrEnCourDeVente:0,
      nbrEnchreDirect:0,
      montantTotalEnventes:0,
      statTransaction:[[],[]],
      encheres:[],
      nbrNonVendu:0,
      nbrEnVente:0,
      containerNeige:'',
      wallet:0,
      emetteur:'',
      viewProfil:{},
      preview:'',
      article_top10:[],
      alltransaction:[],
      factures:[],
      facturesEnCoursLivraison:[],
      facturesEnCoursRecuperation:[],
      factureValide:[],
      facturesAnnule:[],
      nbrEnCourLivraisonCommande:0,
      nbrEnCourRecuperationCommande:0,
      nbrValideCommande:0,
      nbrAnnuleCommande:0,
      allCredit:[],
      allDebit:[],
      note:0,
      relais:'',
      auth:'',
      bannieres:[],
      selectArticleEdit:{},
      selectArticleDetailPage:{},
      villes:[
         'Douala', 
         'Yaoundé', 
         // 'Garoua', 
         // 'Bamenda',
         // 'Maroua', 
         // 'Nkongsamba', 
         // 'Bafoussam', 
         // 'Ngaoundéré', 
         // 'Bertoua', 
         // 'Loum', 
         // 'Kumba', 
         // 'Edéa', 
         // 'Kumbo', 
         // 'Foumban', 
         // 'Mbouda', 
         // 'Dschang', 
         // 'Limbé', 
         // 'Ebolowa', 
         // 'Kousséri', 
         // 'Guider', 
         // 'Meiganga', 
         // 'Yagoua', 
         // 'Mbalmayo', 
         // 'Bafang', 
         // 'Tiko', 
         // 'Bafia', 
         // 'Wum', 
         // 'Kribi', 
         // 'Buea', 
         // 'Sangmélima', 
         // 'Foumbot', 
         // 'Bangangté', 
         // 'Batouri', 
         // 'Banyo', 
         // 'Nkambé', 
         // 'Bali', 
         // 'Mbanga', 
         // 'Mokolo', 
         // 'Melong', 
         // 'Manjo', 
         // 'Garoua-Boulaï', 
         // 'Mora', 
         // 'Kaélé', 
         // 'Tibati', 
         // 'Ndop', 
         // 'Akonolinga', 
         // 'Eséka', 
         // 'Mamfé', 
         // 'Obala', 
         // 'Muyuka', 
         // 'Nanga-Eboko', 
         // 'Abong-Mbang', 
         // 'Fundong', 
         // 'Nkoteng', 
         // 'Fontem', 
         // 'Mbandjock', 
         // 'Touboro', 
         // 'Ngaoundal', 
         // 'Yokadouma', 
         // 'Pitoa', 
         // 'Tombel', 
         // 'Kékem', 
         // 'Magba', 
         // 'Bélabo', 
         // 'Tonga', 
         // 'Maga', 
         // 'Koutaba', 
         // 'Blangoua', 
         // 'Guidiguis', 
         // 'Bogo', 
         // 'Batibo', 
         // 'Yabassi', 
         // 'Figuil', 
         // 'Makénéné', 
         // 'Gazawa', 
         // 'Tcholliré', 
      ],
      FraisServiceVendeur:[], 
      PriseEnChargeAcheteur:[]
   },
   mutations: {
      reset(){
         
      },
      REQUEST_AUTH(state, data) {
         state.auth = data;
      },
      REQUEST_FRAIS_SERVICE_VENDEUR(state, data) {
         state.FraisServiceVendeur = data;
      },
      REQUEST_FRAIS_PRISE_EN_CHARGE_ACHETEUR(state, data) {
         state.PriseEnChargeAcheteur = data;
      },
      REQUEST_VIEW_PROFIL(state, data) {
         state.viewProfil = data;
      },
      REQUEST_RELAI(state, data) {
         state.relais = data;
      },
      REQUEST_SELECT_ARTICLE_DETAIL_PAGE(state, data) {
         state.selectArticleDetailPage = data;
      },
      REQUEST_SELECT_ARTICLE_EDIT(state, data) {
         state.selectArticleEdit = data;
      },
      REQUEST_ROUTER_LAST_POSITION(state, data) {
         state.routerLastPosition[data.name] = data.scrollPosition;
      },
      REQUEST_TOUT_MES_ARTICLES(state, data) {
         state.toutMesArticles = data;
      },
      REQUEST_MES_ARTICLES_EN_VENTES(state, data) {
         state.mesArticlesEnVentes = data;
      },
      REQUEST_MES_ARTICLES_EN_COUR_DE_VENTES(state, data) {
         state.mesArticlesEnCourDeVente = data;
      },
      REQUEST_MES_ARTICLES_NON_VENDUS(state, data) {
         state.mesArticlesNonVendus = data;
      },
      REQUEST_MES_ARTICLES_VENDUS(state, data) {
         state.mesArticlesVendus = data;
      },
      REQUEST_RANGE_SELECT(state, data) {
         state.rangeSelect = data;
      },
      REQUEST_LIST_CATEGORIE_SELECT(state, data) {
         state.listCategorieSelect = data;
      },
      REQUEST_ACCUEIL(state, data) {
        state.dataAccueil = data;
      },
      REQUEST_ALL_ARTICLES(state, data) {
         state.dataArticles = data;
      },
      REQUEST_REAL_HOURS(state, data) {
         state.heure = data
      },
      REQUEST_REAL_TIME(state, data) {
         var heure = data[0] < 10 ? '0' + data[0]:data[0]
         var minutes = data[1] < 10 ? '0' + data[1]:data[1]
         var seconde = data[2] < 10 ? '0' + data[2]:data[2]

         state.realTime = heure + ':' + minutes + ':' + seconde;
      },
      REQUEST_BANNIERES(state, data) {
         state.bannieres = data
      },
   },
   actions: {
      requestAuth(context, data) {
         context.commit("REQUEST_AUTH", data);
      },
      requestFraisServiceVendeur(context, data) {
         context.commit("REQUEST_FRAIS_SERVICE_VENDEUR", data);
      },
      requestFraisPriseEnChargeAcheteur(context, data) {
         context.commit("REQUEST_FRAIS_PRISE_EN_CHARGE_ACHETEUR", data);
      },
      requestViewProfil(context, data) {
         context.commit("REQUEST_VIEW_PROFIL", data);
      },
      requestRelai(context, data) {
         context.commit("REQUEST_RELAI", data);
      },
      requestSelectArticleDetailPage(context, data) {
         context.commit("REQUEST_SELECT_ARTICLE_DETAIL_PAGE", data);
      },
      requestSelectArticleEdit(context, data) {
         context.commit("REQUEST_SELECT_ARTICLE_EDIT", data);
      },
      requestRouterLastPosition(context, data) {
         context.commit("REQUEST_ROUTER_LAST_POSITION", data);
      },
      requestRangeSelect(context, data) {
         context.commit("REQUEST_RANGE_SELECT", data);
      },
      requestToutMesArticles(context, data) {
         context.commit("REQUEST_TOUT_MES_ARTICLES", data);
      },
      requestMesArticlesEnVentes(context, data) {
         context.commit("REQUEST_MES_ARTICLES_EN_VENTES", data);
      },
      requestMesArticlesEnCourDeVente(context, data) {
         context.commit("REQUEST_MES_ARTICLES_EN_COUR_DE_VENTES", data);
      },
      requesMesArticlesNonVendus(context, data) {
         context.commit("REQUEST_MES_ARTICLES_NON_VENDUS", data);
      },
      requestMesArticlesVendus(context, data) {
         context.commit("REQUEST_MES_ARTICLES_VENDUS", data);
      },
      requestListCategorieSelect(context, data) {
         context.commit("REQUEST_LIST_CATEGORIE_SELECT", data);
      },
      requestAccueil(context, data) {
         context.commit("REQUEST_ACCUEIL", data);
      },
      requestAllArticles(context, data) {
         context.commit("REQUEST_ALL_ARTICLES", data);
      },
      requestRealTime(context, data) {
         context.commit("REQUEST_REAL_TIME", data);
      },
      requestHours(context, data) {
         context.commit("REQUEST_REAL_HOURS", data);
      },
      requestBannieres(context, data) {
         context.commit("REQUEST_BANNIERES", data);
      },
   },
})


export default store  
